import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/close-black-icon.svg'
import _imports_1 from '@/assets/lems-v1/images/create-ticket-icon.png'
import _imports_2 from '@/assets/lems-v1/images/upload.svg'


const _hoisted_1 = {
  class: "modal fade createticket-pop",
  id: "createTicket",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "createticket-top" }
const _hoisted_5 = { class: "createticket-btm" }
const _hoisted_6 = { class: "createticket-btm-l" }
const _hoisted_7 = { class: "v1-input-field" }
const _hoisted_8 = { class: "v1-input-field" }
const _hoisted_9 = { class: "v1-input-field" }
const _hoisted_10 = { class: "v1-input-field" }
const _hoisted_11 = { class: "createticket-btm-r" }
const _hoisted_12 = { class: "drag-drop-files" }
const _hoisted_13 = { class: "or" }
const _hoisted_14 = { class: "file-upload" }
const _hoisted_15 = { class: "v1-button-outline" }
const _hoisted_16 = { class: "form-submit" }
const _hoisted_17 = {
  class: "v1-button-outline",
  id: "createTicketBtn"
}
const _hoisted_18 = {
  class: "v1-button-outline-black",
  id: "canceTicketlBtn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pop-close" }, [
          _createElementVNode("button", {
            "data-bs-dismiss": "modal",
            id: "createTicketPopClose"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              width: "100%"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("i", null, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants.CREATE_TICKET_TEXT), 1)
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_ctx.constants.SELECT_PROJECT_LABEL) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "*", -1))
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("select", {
                  id: "createTicketSelectProSelectBox",
                  class: "custom-select-box"
                }, [
                  _createElementVNode("option", null, "Select Project")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_ctx.constants.SUMMERY_LABEL) + " ", 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "*", -1))
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("textarea", {
                  id: "createTicketSummaryInput",
                  class: "height-80",
                  placeholder: "Enter the ticket summery "
                }, null, -1)),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "count-info" }, "(255)", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "info-txt" }, " You must specify the summary to this issue. ", -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_ctx.constants.TICKET_TYPE_LABEL) + " ", 1),
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, "*", -1))
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("select", {
                  class: "custom-select-box",
                  id: "createTicketSelectTicketTypeSelectBox"
                }, [
                  _createElementVNode("option", null, "Ticket Type"),
                  _createElementVNode("option", null, "Technical task")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                _cache[9] || (_cache[9] = _createElementVNode("textarea", {
                  id: "createTicketDescriptionInput",
                  class: "height-80",
                  placeholder: "Description"
                }, null, -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[10] || (_cache[10] = _createElementVNode("i", null, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: ""
                    })
                  ], -1)),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.constants.DRAG_AND_DROP_FILES_TEXT), 1)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.constants.OR_TEXT), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.constants.UPLOAD_LABEL), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("input", {
                    id: "createTicketUploadInput",
                    type: "file"
                  }, null, -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.constants.CREATE_BUTTON), 1),
            _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}